import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { useMemo } from 'react'

export function useOrderedServiceList(services: ILeadOppProduct[]) {
  const ordered = useMemo(
    () => services.sort((a, b) => a.sortOrder - b.sortOrder),
    [services],
  )
  return ordered
}
